import * as React from 'react'
import styled, { css } from 'styled-components'
import { containerNarrow, containerDefault } from '../../lib/styles/Container'
import { TeaserCardItem } from '../TeaserCardItem'
import { TeaserCardProductItem } from '../TeaserCardProductItem'
import { TeaserCardGridProps } from './types'

const GridItem = styled.div`
  & > * {
    height: 100%;
  }
`

const WrapperContainer = styled.div<{
  columns: number
  showOnMobile?: boolean
}>`
  width: 100%;
  max-width: 80vw;
  margin: 0 auto;

  @media (max-width: 992px) {
    width: 100%;
    max-width: 100%;
  }

  @media (max-width: 640px) {
    width: 100%;
    max-width: 100%;
  }
    
  ${p =>
    !p.showOnMobile &&
    css`
      @media screen and (max-width: 820px) {
        display: none;
      }
    `}
`

const columnsWrapperJustifyContent = {
  left: 'start',
  center: 'center',
}

const ColumnsWrapper = styled.div<{
  columns?: number
  $width?: string
  $align?: 'left' | 'center'
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: ${({ $align }) => ($align ? columnsWrapperJustifyContent[$align] : 'center')};

  @media screen and (max-width: 820px) {
    margin: 0;
    justify-content: center;
    flex-direction: column;
  }

  ${GridItem} {
    flex: 1 1 calc(50% - 0.5rem); // Default to 2 columns

    // For 2 or 3 items
    &:first-child:nth-last-child(2),
    &:first-child:nth-last-child(2) ~ ${GridItem},
    &:first-child:nth-last-child(3),
    &:first-child:nth-last-child(3) ~ ${GridItem} {
      flex: 1 1 calc(33.333% - 0.667rem);
    }

    // For 4 items
    &:first-child:nth-last-child(4),
    &:first-child:nth-last-child(4) ~ ${GridItem} {
      flex: 1 1 calc(50% - 0.5rem);
    }

    @media screen and (max-width: 1024px) {
      flex: 1 1 calc(50% - 0.5rem);
    }

    @media screen and (max-width: 820px) {
      flex: 1 1 100%;
      padding: 0;
    }
  }
`

export const Columns = ({ blok, $align = 'center' }: TeaserCardGridProps) => {
  return (
    <WrapperContainer columns={3} showOnMobile={!blok.isMobileSlider}>
      <ColumnsWrapper columns={3} $align={$align} $width={blok.items.length > 2 ? '50' : '100'}>
        {blok.items.map(item => (
          <GridItem key={item._uid}>
            {item.component === 'TeaserCardItem' ? (
              <TeaserCardItem blok={item} justify={item.Alignment ? item.Alignment : 'left'} direction={item.direction ? item.direction as 'row' | 'column' : 'column'} width={blok.items.length > 2 ? '50' : '100'} />
            ) : (
              <TeaserCardProductItem blok={item} />
            )}
          </GridItem>
        ))}
      </ColumnsWrapper>
    </WrapperContainer>
  )
}
